import { render, staticRenderFns } from "./alias_list.vue?vue&type=template&id=20264a67&scoped=true&"
import script from "./alias_list.vue?vue&type=script&lang=js&"
export * from "./alias_list.vue?vue&type=script&lang=js&"
import style0 from "./alias_list.vue?vue&type=style&index=0&id=20264a67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20264a67",
  null
  
)

export default component.exports